app.controller("GradesStatisticsController", ["$scope", "$stateParams", "$httpParamSerializer", "StaticData", "ProgramService", "Selection", "Students", "Subject", "$uibModal", "$state", "usSpinnerService",
    function ($scope, $stateParams, $httpParamSerializer, StaticData, ProgramService, Selection, Students, Subject, $uibModal, $state, usSpinnerService) {
        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.gradeList = null;
        $scope.student = $stateParams.student || null;
        $scope.personalNo = $stateParams.personalNo || null;
        $scope.level = $stateParams.level || null;
        $scope.studentState = null;
        $scope.selectionState = $stateParams.selectionState || null;
        $scope.season = null;
        $scope.faculty = $stateParams.faculty || null;
        $scope.subject = $stateParams.subject || null;
        $scope.semester = null;
        $scope.semesters = [{_id:null, name:'სემესტრი'}].concat(_.range(1, 15).map(function(el){
            return {_id:el, name: el};
        }));
        $scope.format = "dd-MM-yyyy";
        var now = new Date();
        $scope.years = _.range(2017, now.getFullYear() + 1);
        $scope.selectedFaculties = [];
        $scope.selectedPrograms = [];
        $scope.selectedStudentStates = $stateParams.studentStates || [];
        $scope.selectedSemesters = $stateParams.semesters || [];
        $scope.selectedSeasons = $stateParams.seasons || [];

        $scope.popup1 = {
            opened: false
        };

        $scope.popup2 = {
            opened: false
        };

        if ($stateParams.programs && $stateParams.programs.length) {
            Promise.all($stateParams.programs.map(function(program){
                return ProgramService.fetchOne(program);
            })).then(function (selectedPrograms) {
                $scope.selectedPrograms = selectedPrograms;
            });
        }

        if ($stateParams.student) {
            Students.list({profileId: $stateParams.student}).then(function (data) {
                $scope.student = data.docs[0];
            });
        }

        if ($stateParams.subject) {
            Subject.fetchOne($stateParams.subject).then(function (data) {
                $scope.subject = data.subject;
            });
        }

        $scope.openFromDate = function () {
            $scope.popup1.opened = true;
        };

        $scope.openToDate = function () {
            $scope.popup2.opened = true;
        };

        StaticData.getItemsByKey("levels").then(function (levels) {
            $scope.levels = [{name: "საფეხური"}].concat(levels);
            $scope.levelsMap = _.keyBy($scope.levels, '_id');
        });

        StaticData.getItemsByKey("subject_states").then(function (subjectStates) {
            $scope.subjectStatesMap = _.keyBy(subjectStates, '_id');
        });

        StaticData.getItemsByKey("states").then(function (states) {
            $scope.studentStates = [{name: "სტუდენტის სტატუსი"}].concat(states);
            $scope.studentStatesMap = _.keyBy($scope.studentStates, '_id');
            $scope.selectedStudentStates = _.map($stateParams.studentStates, function(s) {
                return $scope.studentStatesMap[s];
            });
        });

        StaticData.getItemsByKey("subject_states").then(function (st) {
            $scope.selectionStates = [{name: "ქულის სტატუსი"}].concat(st);
            $scope.selectionStatesMap = _.keyBy($scope.states, '_id');
        });

        StaticData.getItemsByKey("faculties").then(function (fs) {
            $scope.faculties = [{name: "ფაკულტეტი"}].concat(fs);
            var facultiesMap = _.keyBy($scope.faculties, '_id');
            $scope.selectedFaculties = _.map($stateParams.faculties, function(s) {
                return facultiesMap[s];
            });
        });

        StaticData.getItemsByKey("subject_seasons").then(function (seasons) {
            $scope.seasons = [{'name': 'სეზონი'}, {'_id': 'not defined' ,'name': 'არ არის განსაზღვრული'}];
            $scope.years.forEach(function (year) {
                seasons.forEach(function (season) {
                    $scope.seasons.push({
                        _id: year + '-' + season._id,
                        name: year + ' ' + season.name
                    });
                });
            });
            var seasonsMap = _.keyBy($scope.seasons, '_id');

            $scope.selectedSeasons = _.map($stateParams.seasons, function(s) {
                return seasonsMap[s];
            });
        });

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        $scope.getStudents = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Students.list({query: query}).then(function (data) {
                return data.docs;
            });
        };

        $scope.getPrograms = function (name) {
            if (name.length < 1) {
                return [];
            }
            var params = {};
            params.query = name;
            return ProgramService.list(params).then(function (data) {
                return data.docs;
            });
        };

        $scope.getSubjects = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Subject.list({query: query}).then(function (data) {
                return data.docs;
            });
        };

        $scope.loadPage = function (page) {
            return Selection.gradeStatistics({
                page: page || 1,
                limit: $scope.itemsPerPage,
                student: $stateParams.student || null,
                personalNo: $stateParams.personalNo || null,
                level: $stateParams.level || null,
                semesters: $stateParams.semesters,
                programs: $stateParams.programs,
                subject: $stateParams.subject || null,
                faculties: $stateParams.faculties,
                studentStates: $stateParams.studentStates,
                selectionState: $stateParams.selectionState || null,
                seasons: $stateParams.seasons
            }).then(function (data) {
                $scope.gradeList = data.docs;
                $scope.totalItems = data.total;
            })
        };

        usSpinnerService.spin("root");
        $scope.loadPage($stateParams.page).then(function () {
            usSpinnerService.stop("root");
            $scope.currentPage = $stateParams.page;
        });

        $scope.applyFilter = function () {
            $state.go(".", {
                page: $scope.page,
                limit: $scope.itemsPerPage,
                student: $scope.student ? $scope.student._id : null,
                personalNo: $scope.personalNo || null,
                level: $scope.level || null,
                semesters: $scope.selectedSemesters,
                programs: _.map($scope.selectedPrograms, '_id'),
                subject: $scope.subject ? $scope.subject._id : null,
                faculties: _.map($scope.selectedFaculties, '_id'),
                studentStates: _.map($scope.selectedStudentStates, '_id'),
                selectionState: $scope.selectionState || null,
                seasons: _.map($scope.selectedSeasons, '_id')
            });
        };

        $scope.export = function () {
            var qs = $httpParamSerializer({
                student: $scope.student ? $scope.student._id : null,
                personalNo: $scope.personalNo || null,
                level: $scope.level || null,
                semesters: $scope.selectedSemesters,
                programs: _.map($scope.selectedPrograms, '_id'),
                subject: $scope.subject ? $scope.subject._id : null,
                faculties: _.map($scope.selectedFaculties, '_id'),
                studentStates: _.map($scope.selectedStudentStates, '_id'),
                selectionState: $scope.selectionState || null,
                seasons: _.map($scope.selectedSeasons, '_id')
            });
            window.open('/selection/grade/statistics/export?' + qs);
        };

        $scope.exportCustom = function(reportName) {
            if(reportName === 'NOT_ALLOWED_ON_FINALS') {
                var queryString = $httpParamSerializer({
                    report: reportName,
                    selectionState: 'current'
                });
                window.open('/selection/grade/statistics/export?' + queryString);
            }
        };

        $scope.addFacultyToFilter = function () {
            if ($scope.selectedFaculties.map(function (fac) {
                return fac._id
            }).indexOf($scope.faculty) > -1) return;
            $scope.selectedFaculties.push($scope.faculties.find(function (f) {
                return f._id === $scope.faculty
            }));
            $scope.faculty = null;
        };

        $scope.removeFaculty = function (faculty) {
            $scope.selectedFaculties = $scope.selectedFaculties.filter(function (f) {
                return f !== faculty;
            });
        };

        $scope.addProgramToFilter = function () {
            if ($scope.selectedPrograms.indexOf($scope.program) > -1) return;
            $scope.selectedPrograms.push($scope.program);
            $scope.program = null;
        };

        $scope.removeProgram = function (pr) {
            $scope.selectedPrograms = $scope.selectedPrograms.filter(function (p) {
                return p._id !== pr._id
            });
        };

        $scope.addStateToFilter = function () {
            if ($scope.selectedStudentStates.map(function (st) {
                return st._id
            }).indexOf($scope.studentState) > -1) return;
            $scope.selectedStudentStates.push($scope.studentStates.find(function (s) {
                return s._id === $scope.studentState
            }));
            $scope.studentState = $scope.studentStates[0]._id;
        };

        $scope.removeState = function (st) {
            $scope.selectedStudentStates = $scope.selectedStudentStates.filter(function (s) {
                return s !== st
            });
        };

        $scope.addSemesterToFilter = function () {
            if ($scope.selectedSemesters.indexOf($scope.semester) > -1) return;
            $scope.selectedSemesters.push($scope.semester);
            $scope.semester = $scope.semesters[0]._id;
        };

        $scope.removeSemester = function (sem) {
            $scope.selectedSemesters = $scope.selectedSemesters.filter(function (s) {
                return s !== sem
            });
        };

        $scope.addSeasonToFilter = function () {
            if ($scope.selectedSeasons.indexOf($scope.season) > -1) return;
            $scope.selectedSeasons.push($scope.seasons.find(function (s) {
                return s._id === $scope.season;
            }));
            $scope.season = null;
        };

        $scope.removeSeason = function (season) {
            $scope.selectedSeasons = $scope.selectedSeasons.filter(function (s) {
                return s !== season
            });
        };
    }]);
